import { createSelector } from 'reselect';

import { DEFAULT_LANGUAGE } from 'constants/LanguageConstants';
import { STATUS_DELETED } from 'constants/MediaConstants';
import { getProps } from 'utils/selectors';

/** @return {import('../reducers').ReleasesReducer} */
const getReleasesState = state => state.releases;

const getDataState = createSelector(getReleasesState, state => state.data);

export const getUIState = createSelector(getReleasesState, state => state.ui);

export const getReleasesIds = createSelector(getDataState, state => state.ids);

export const getReleasesEntities = createSelector(getDataState, state => state.entities);

export const getDashboardUIState = createSelector(getUIState, state => state.dashboard);

export const getFiltersState = createSelector(getDashboardUIState, state => state.filters);

export const getReleaseById = createSelector(
  getReleasesEntities,
  getProps,
  (entities, releaseId) => entities[releaseId]
);

export const getAllReleases = createSelector(getReleasesEntities, getReleasesIds, (entities, ids) =>
  ids.map(id => entities[id]).filter(Boolean));

export const getReleaseByIds = createSelector(getReleasesEntities, getProps, (entities, releaseIds) =>
  releaseIds.map(releaseId => entities[releaseId]).filter(Boolean));

export const canPublishRelease = createSelector(
  getReleaseById,
  (release) =>
    release?.notes?.length > 0 &&
    release.notes.every(note => {
      const defaultContent = note.content?.[DEFAULT_LANGUAGE];
      return defaultContent?.media && defaultContent.media.status !== STATUS_DELETED;
    })
);
